import * as React from "react";
import { LocalizedText } from "bernie-l10n";
import { locKeys } from "src/components/flexComponents/WizardHotelPWA/components/l10n";

export const LegalText = ({ showMoreStrategy }: { showMoreStrategy: string }) => {
  const legalRequirementClassName =
    showMoreStrategy !== "top_link"
      ? "uitk-type-200 all-b-padding-six uitk-type-center"
      : "uitk-type-200 all-b-padding-six all-t-padding-three uitk-type-center";

  return (
    <div className={`legalText ${legalRequirementClassName}`}>
      <LocalizedText message={locKeys.hotelLegalDisclaimer} />
    </div>
  );
};
